export enum AvailabilityStatus {
  Available = 'available',
  Away = 'away',
}
